const tagsToString = tagsArray =>
    tagsArray.map(([tag, value]) => `${tag}:${value}`);

export const buildTagsQuery = tags => {
    const { values = {}, filterBy = [] } = tags;
    const tagsArray = Object.entries(values).filter(([tag]) =>
        filterBy.includes(tag)
    );
    const params = tagsToString(tagsArray).map(
        tag => "tag=" + encodeURIComponent(tag)
    );
    return params.join("&");
};

export const tagsToArray = tags =>
    tagsToString(Object.entries(tags.values || {}));
